export default __webpack_public_path__ + "static/media/laptopTabImg.f4e375ac.png";